<template>
    <app-layout>
        <template #header>
             <div class="md:grid md:grid-cols-3 md:gap-6">
                <h2 class="md:col-span-2 font-semibold text-xl text-gray-800 leading-tight">
                    User's details
                </h2>
            </div>
        </template>
        <div class="mx-4 sm:mx-8 px-4 sm:px-8 py-4">
             <div class="md:grid md:grid-cols-4 md:gap-6">
                 <div class="md:col-span-3">
                    <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
                        <form @submit.prevent="submit">
                            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                               <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Name" />
                               <text-input v-model="form.email" :error="errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="E-mail" />
                               <!-- <text-input v-model="form.password" :error="errors.password" class="pr-6 pb-8 w-full lg:w-1/2" label="Password" /> -->
                                <div class="pr-6 pb-8 w-full lg:w-1/2">
                                    <label class="form-label">Role:</label>
                                    <select class="form-input" v-model="user.role_id">
                                        <!-- <option value="1">Super Admin</option> -->
                                        <option value="2">Organization Admin</option>
                                        <option value="3">Trainer</option>
                                        <option value="4">Client</option>
                                    </select>
                                <div class="pt-5">
                                    <label class="text-gray-700 capitalize" for="name">Send Notification to User</label>
                                    <input class="px-4 " type="checkbox" >
                                </div>
                                </div>
                            </div>
                            <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex text-right">
                                <button type="submit" class="px-5 py-2 bg-gray-800 text-gray-200 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-700">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import UploadProfilePhoto from './../../../Components/UploadProfilePhoto'
import TextInput from './../../../Components/TextInput'
import ManagerLayout from './../../../Layouts/ManagerLayout'

export default {
    metaInfo() {
        return {
            title: 'Lista Korisnika' 
        }
    },
    components: {
        AppLayout,
        UploadProfilePhoto,
        TextInput
    },
    props: {
        user: Object,
        errors: Object
    },
    data(){
        return{
            form: {
                id: this.user.id,
                name: this.user.name,
                email: this.user.email,
                role_id:this.user.role_id
                // password: this.user.password
               
                
            },
        }
    },
    methods:{
        submit() {
            this.sending = true
            this.$inertia.put('/backoffice/users/update/'+ this.user.id, this.form)
                .then(() => this.sending = false)
        },
    }
}
</script>